





































































































































import { Mixins, Component } from "vue-property-decorator";
import { NumberInput } from "../../../../../../../base/components/system";
import { DialogMixin } from "../../../../../../../base/components/system/mixins";
import { ObjectUtility } from "../../../../../../../base/utilities";
import { ILineGraphItem, ILineGraphPair, ILineGraphLinkedObjectSpecifiable } from "../../../../../../../documaker/domain/format/objects";
import { LineGraphItemSelector, LineGraphLinkedObjectSelector, LineGraphPairSelector } from "../selectors";
import { IFormatObjectEditable } from "../../../../../../../formatEditor/domain/editableFormat";

@Component({
  components: {
    NumberInput,
    LineGraphItemSelector,
    LineGraphLinkedObjectSelector,
    LineGraphPairSelector,
  }
})
export default class LineGraphItemEditDialog extends Mixins(DialogMixin) {
  items: ILineGraphItem[] = [];
  selectionObjects: { pageKey: number, object: IFormatObjectEditable }[] = [];
  toPageNumberCellString: (row: ILineGraphLinkedObjectSpecifiable) => string = () => "";

  selectedItem: ILineGraphItem = null;
  selectedDateTimeObject: ILineGraphLinkedObjectSpecifiable = null;
  selectedValueObject: ILineGraphLinkedObjectSpecifiable = null;
  selectedPairs: ILineGraphPair[] = [];

  itemName: string = "";
  itemMin: number = 0;
  itemMax: number = 100;
  itemIsTimeAxisDate: boolean = false;
  itemColor: string = "#ffffff";

  confirmed: boolean = false;

  get dateObjects(): ILineGraphLinkedObjectSpecifiable[] {
    return this.selectionObjects
      .map(v => this.toLineGraphLinkedObjectSpecifiable(v.pageKey, v.object))
      .filter(v => v.type === "date" && v.isDate === true);
  }

  get timeObjects(): ILineGraphLinkedObjectSpecifiable[] {
    return this.selectionObjects
      .map(v => this.toLineGraphLinkedObjectSpecifiable(v.pageKey, v.object))
      .filter(v => v.type === "date" && v.isDate === false);
  }

  get valueObjects(): ILineGraphLinkedObjectSpecifiable[] {
    return this.selectionObjects
      .map(v => this.toLineGraphLinkedObjectSpecifiable(v.pageKey, v.object))
      .filter(v => v.type === "text" || v.type === "calculate");
  }

  private toLineGraphLinkedObjectSpecifiable(pageKey: number, object: IFormatObjectEditable): ILineGraphLinkedObjectSpecifiable {
    const linkedObject = object.toLinkedObjectIdentifier();
    return {
      page: pageKey,
      type: linkedObject.type,
      id: linkedObject.id,
      key: linkedObject.key,
      subKey: linkedObject.subKey,
      isDate: linkedObject.isDate,
    };
  }

  get hasItemName(): boolean {
    return this.itemName !== "";
  }

  get hasSelectedItem(): boolean {
    return !!this.selectedItem;
  }

  get isTopSelectedItem(): boolean {
    return this.hasSelectedItem && this.selectedItem === this.items[0];
  }

  get isBottomSelectedItem(): boolean {
    return this.hasSelectedItem && this.selectedItem === this.items[this.items.length - 1];
  }

  get hasSelectedDateTimeObject(): boolean {
    return !!this.selectedDateTimeObject;
  }

  get hasSelectedValueObject(): boolean {
    return !!this.selectedValueObject;
  }

  get hasSelectedPairs(): boolean {
    return this.selectedPairs.length > 0;
  }

  get dateTimeLabel(): string {
    return this.hasSelectedItem
      ? this.selectedItem.isTimeAxisDate
        ? "名称(時間)"
        : "名称(日付)"
      : "名称";
  }

  get dateTimeObjects(): ILineGraphLinkedObjectSpecifiable[] {
    return this.hasSelectedItem
      ? this.selectedItem.isTimeAxisDate
        ? this.timeObjects
        : this.dateObjects
      : [];
  }

  get pairs(): ILineGraphPair[] {
    return this.hasSelectedItem
      ? this.selectedItem.pairs
      : [];
  }

  async show(
    items: ILineGraphItem[],
    selectionObjects: { pageKey: number, object: IFormatObjectEditable }[],
    toPageNumberCellString: (row: ILineGraphLinkedObjectSpecifiable) => string): Promise<ILineGraphItem[]> {
    
    return this.showModal(async () => {
      this.items = ObjectUtility.copyDeeply(items);
      this.selectionObjects = selectionObjects;
      this.toPageNumberCellString = toPageNumberCellString;

      this.selectedItem = null;
      this.selectedDateTimeObject = null;
      this.selectedValueObject = null;
      this.selectedPairs = [];

      this.itemName = "";
      this.itemMin = 0;
      this.itemMax = 100;
      this.itemIsTimeAxisDate = false;
      this.itemColor = "#ffffff";

      this.confirmed = false;
      await this.waitHidden();
      return this.confirmed ? this.items : null;
    });
  }

  addItem() {
    this.items = this.items.concat({
      name: this.itemName,
      range: {
        min: this.itemMin,
        max: this.itemMax,
      },
      isTimeAxisDate: this.itemIsTimeAxisDate,
      lineStyle: {
        kind: 1,
        color: {
          value: this.itemColor ? this.itemColor : "#ffffff",
        },
        width: 0,
        opacity: 1,
      },
      pairs: [],
    });
  }

  updateItem() {
    this.selectedItem.name = this.itemName;
    this.selectedItem.range.min = this.itemMin;
    this.selectedItem.range.max = this.itemMax;
    if (this.selectedItem.pairs.length === 0) {
      this.selectedItem.isTimeAxisDate = this.itemIsTimeAxisDate;
    } else if (this.selectedItem.isTimeAxisDate !== this.itemIsTimeAxisDate) {
      this.$warn("項目更新", "組み合わせがすでにある場合は「日付・時間」の更新は行われません。");
    }
    this.selectedItem.lineStyle.color.value = this.itemColor ? this.itemColor : "#ffffff";
  }

  moveItem(offset: number) {
    const index = this.items.indexOf(this.selectedItem);
    const item = this.items[index];
    this.items.splice(index, 1);
    this.items.splice(index + offset, 0, item);
  }

  removeItem() {
    this.items = this.items.filter((v) => v !== this.selectedItem);
  }

  addPair() {
    this.selectedItem.pairs = this.selectedItem.pairs.concat({
      timeAxis: ObjectUtility.copyDeeply(this.selectedDateTimeObject),
      value: ObjectUtility.copyDeeply(this.selectedValueObject),
    });
  }

  removePairs() {
    this.selectedItem.pairs = this.pairs.filter((v) => !this.selectedPairs.some(s => s === v));
  }

  changeItem(value: ILineGraphItem) {
    this.selectedItem = value;
    if (!!value) {
      const item = ObjectUtility.copyDeeply(value) as ILineGraphItem;
      this.itemName = item.name;
      this.itemMin = item.range.min;
      this.itemMax = item.range.max;
      this.itemIsTimeAxisDate = item.isTimeAxisDate;
      this.itemColor = item.lineStyle.color.value;
    }
  }

  changeDateTimeObject(value: ILineGraphLinkedObjectSpecifiable) {
    this.selectedDateTimeObject = value;
  }

  changeValueObject(value: ILineGraphLinkedObjectSpecifiable) {
    this.selectedValueObject = value;
  }

  changePairs(value: ILineGraphPair[]) {
    this.selectedPairs = value;
  }

  confirm(): void {
    this.confirmed = true;
    this.isVisible = false;
  }

  cancel(): void {
    this.isVisible = false;
  }
}
